import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./naming-section.scss";
import {UseState} from "../../../../../../../../../react/use-state";
import {Invoke} from "../../../../../../../../../react/invoke";
import {stateChangeNestedValue} from "../../../../../../../../../react/state-change-nested-value";
import {ErrorHighlighter} from "../../../../../../../../light/error-highlighter";
import {cx} from "emotion";
import {EditingPanel} from "./editing-panel/editing-panel";
import {ViewingPanel} from "./viewing-panel/viewing-panel";
import {createArray} from "../../../../../../../../../utils/collections";

export const NamingSection = ({listIndex, next}) => cs(
    ["allNamings", (_, next) => UseState({next})],
    ["editing", (_, next) => UseState({next})],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ({allNamings, editing, eh}) => next({
        valid: !editing.value,
        highlightErrors: () => {
            stateChangeNestedValue(editing, ["showErrors"], () => true);
            eh.start();
        },
        render: ({count, onApply, onApplyAll}) => (
            <div className={cx("naming-section-5ob", eh.css)}>
                {Invoke({action: () => editing.onChange(null)})}

                {editing.value ? (
                    EditingPanel({
                        getInitData: () => allNamings.value?.[listIndex] ?? {type: "owner"},
                        showErrors: editing.value.showErrors,
                        count,
                        onCancel: () => editing.onChange(null),
                        onApply: async (data) => {
                            await onApply(data);
                            stateChangeNestedValue(allNamings, [listIndex], () => data);
                            editing.onChange(null);
                        },
                        onApplyAll: async (data) => {
                            await onApplyAll(data);
                            allNamings.onChange(createArray(count).map(() => data));
                            editing.onChange(null);
                        },
                    })
                ) : (
                    ViewingPanel({
                        data: allNamings.value?.[listIndex] ?? {type: "owner"},
                        onEdit: () => editing.onChange({}),
                    })
                )}
            </div>
        ),
    }),
);
